export enum RetrieveAllTransactionsMode {
  SUMMARY = 1,
  DETAILS = 2,
}

export enum TransactionStatus {
  CAPTURE = 1,
  PRE_AUTH = 2,
  PURCHASED = 3,
  VOID = 4,
  REFUND = 5,
  DECLINED = 6,
  PENDING = 7,
  EXPIRED = 8,
  CANCELLED = 9,
}

export enum TransactionType {
  CREDIT_PIN = 1,
  CREDIT_SIGNATURE = 2,
  CREDIT_MANUAL = 3,
  DEBIT_PIN = 4,
  CREDIT_SWIPE = 5,
  CHEQUE = 6,
  EBT_SWIPE_PIN = 7,
  CASH = 8,
  EMV = 9,
  CARD_NOT_PRESENT = 10,
  PAYMAYA_QR = 11,
  GCASH_QR = 12,
  PAYMAYA_QR_PH = 13,
  PAYMAYA_WALLET_LINK = 14,
}

export enum Currency {
  PHP = 1,
  USD = 2,
}

export enum CardType {
  MASTERCARD = 1,
  VISA = 2,
  AMERICAN_EXPRESS = 3,
  DINERS = 4,
  DISCOVER = 5,
  JCB = 6,
  CHINABANK = 7,
  CITIBANK = 8,
  BARCLAY_CARD = 9,
  DEBIT = 10,
  CHEQUE = 11,
  CASH = 12,
  EBT = 13,
  OFFLINE = 14,
  PAYMAYA_QR = 15,
  GCASH_QR = 16,
  PAYMAYA_QR_PH = 17,
  PAYMAYA_WALLET_LINK = 18,
  AUB = 19,
}
